import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/styles/withStyles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import AddIcon from '@material-ui/icons/Add';
import './EventSlider.css';
import { API_URL } from '../common/Constants';

const moment = require('moment');
function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} style={{ display: 'block' }} onClick={onClick}>
      <ArrowForwardIosIcon size="25" style={{ cursor: 'pointer' }} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} style={{ display: 'block' }} onClick={onClick}>
      <ArrowBackIosIcon size="25" style={{ cursor: 'pointer' }} />
    </div>
  );
}
const styles = (theme) => ({
  titleSlider: {
    fontSize: '1.1em',
    color: '#333',
    paddingLeft: '20px',
    width: '30%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      fontSize: '1.0em',
      width: '80%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75em',
    },
  },
  notiOuter: {
    padding: '2vh 0',
    width: '80%',
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
});
class EventSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeData: [],
      isToggleOn: true,
      autoplay: true,
    };
    this.handleBtnClick = this.handleBtnClick.bind(this);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/bbs/event/list`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        if (response.data) {
          let _result = response.data.sort((a, b) => {
            return b.createdAt - a.createdAt;
          });
          this.setState({ noticeData: _result });
        }
      });
  }

  handleBtnClick() {
    this.setState(
      {
        isToggleOn: !this.state.isToggleOn,
      },
      () => {
        if (this.state.isToggleOn) {
          this.play();
        } else {
          this.pause();
        }
      },
    );
  }

  play() {
    this.slider.slickPlay();
  }
  pause() {
    this.slider.slickPause();
  }

  render() {
    const settings = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      vertical: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };

    // 공지사항 최신순(역순) 5개만
    const slides = this.state.noticeData
      .slice(0, this.state.noticeData.length < 5 ? this.state.noticeData.length : 5)
      .map((notiItem, i) => {
        return (
          <Grid key={`eventslider-grid-${i}`}>
            <Grid container key={`eventslider-grid-container-${i}`}>
              <Grid
                item
                xs={12}
                sm={8}
                onClick={() => {
                  this.props.history.push({
                    pathname: '/evtnoti',
                    state: { pageState: 'detail', notiItems: notiItem },
                  });
                }}
                className="notiTitle"
                key={`eventslider-grid-item-${i}`}
              >
                {notiItem.title}
              </Grid>
              <Grid item xs={4} className="createdAt" key={`eventslider-moment-${i}`}>
                {moment(Number(notiItem.createdAt)).format('YYYY-MM-DD')}
              </Grid>
            </Grid>
          </Grid>
        );
      });
    const { classes } = this.props;
    return (
      <Grid container justify="center" alignItems="center" className={classes.notiOuter}>
        <Grid item container xs={12} justify="space-between">
          <Grid
            item
            xs={2}
            sm={3}
            style={{ fontSize: '1.2em', fontWeight: 'bold', cursor: 'pointer', display: 'flex' }}
            onClick={() => {
              this.props.history.push({
                pathname: '/evtnoti',
                state: { pageState: 'list', notiItems: null },
              });
            }}
          >
            <div className={classes.titleSlider}>
              <span>이</span>
              <span>벤</span>
              <span>트</span>
            </div>
          </Grid>
          <Grid item xs={8} style={this.state.noticeData.length < 2 ? { cursor: 'pointer', height: 26 } : { cursor: 'pointer' }}>
            {this.state.noticeData != null && this.state.noticeData.length > 0 && (
              <Slider ref={(slider) => (this.slider = slider)} {...settings}>
                {slides}
              </Slider>
            )}
          </Grid>

          <Grid
            item
            xs={2}
            sm={1}
            container
            justify="flex-start"
            alignItems="center"
            onClick={() => this.handleBtnClick()}
            style={{ position: 'relative' }}
          >
            {this.state.isToggleOn ? (
              <Grid container item xs={6}>
                <PauseIcon size="25" style={{ cursor: 'pointer', color: '#777' }} />
              </Grid>
            ) : (
              <Grid container item xs={6}>
                <PlayArrowIcon size="25" style={{ cursor: 'pointer', color: '#777' }} />
              </Grid>
            )}
            <AddIcon
              onClick={() => {
                this.props.history.push({
                  pathname: '/evtnoti',
                  state: { pageState: 'list', notiItems: null },
                });
              }}
              style={{ position: 'absolute', left: '50px', color: '#777', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(EventSlider));
